import React from "react";
import Page1 from "./pages/PageNum1";
import Page2 from "./pages/PageNum2";
import Page3 from "./pages/PageNum3";
import Page4 from "./pages/PageNum4";
import ErrorPage from "./error-page";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Page1 />
        <Page2 />
        <Page3 />
        <Page4 />
      </>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/Page2",
    element: <Page2 />,
  },
  {
    path: "/Page3",
    element: <Page3 />,
  },
  {
    path: "/Page4",
    element: <Page4 />,
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
